import { BrowserWebService } from "./browser-web";
import { ExtensionIframeService } from "./extension-iframe";
import { AppWebViewService } from "./app-webview";
import { CHROME_EXT_PROTOCOL, PlatformService, PlatformId, ServiceOptions } from "./base";
import { __IS_DEV__ } from "./utils";

export class PlatformServiceFactory {
  static createService(options?: ServiceOptions): PlatformService {
    if (this.isAppWebViewEnvironment()) {
      return new AppWebViewService(options);
    }
    if (this.isBrowserWebEnvironment()) {
      return new BrowserWebService(options);
    } else if (this.isExtensionIframeEnvironment()) {
      return new ExtensionIframeService(options);
    }
    throw new Error('Not support environment');
  }

  static isBrowserWebEnvironment(): boolean {
    return window.top === window.self
  }

  static isAppWebViewEnvironment(): boolean {
    // const hasSipObject = window.sip?.providers?.solana;
    const userAgent = navigator.userAgent.toLowerCase();
    const isWebViewUA = userAgent.includes('sip');
    // return hasSipObject && isWebViewUA;
    return isWebViewUA;
  }

  static isExtensionIframeEnvironment(): boolean {
    return (window.top !== window.self && document.location.ancestorOrigins[0]?.startsWith(CHROME_EXT_PROTOCOL))
  }
}

export let platformService = PlatformServiceFactory.createService({
  isDev: __IS_DEV__
})

export function initPlatformService(options?: ServiceOptions) {
  platformService = PlatformServiceFactory.createService(options)
}

export function isInExt () {
  return PlatformServiceFactory.isExtensionIframeEnvironment()
}

export function isInApp () {
  return PlatformServiceFactory.isExtensionIframeEnvironment()
}

export function isInWeb () {
  return PlatformServiceFactory.isBrowserWebEnvironment()
}
